import React from "react";
import logger from "logger";
import { fade, withStyles, makeStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: "6px", //theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "7px 5px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: "5px", //theme.spacing(1),
  },
}));

export default function CustomizedInputs(props) {
  const { label, key, valueholder, type = "text", ...rest } = props;
  const classes = useStyles();

  const isValid = valueholder && valueholder.value;

  return (
    <div className={classes.root}>
      <FormControl className={classes.margin} error={!isValid}>
        <BootstrapInput
          defaultValue=""
          id={`bootstrap-input-${key}`}
          value={valueholder.value}
          {...valueholder}
          placeholder={label}
          type={type}
          {...rest}
        />
        {!isValid && <FormHelperText>{`${label} is required.`}</FormHelperText>}
      </FormControl>
    </div>
  );
}
